function prevencao(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"Evite aglomerações e sempre utilize máscara em locais públicos. Higienize as mãos frequentemente com água e sabão ou com álcool 70%.",
						"title":"Como se prevenir?",
						"image":"images/games/informs/prevencao/1.png",
					},
					{
						"text":"Evitar: contato físico com outras pessoas; tocar seus olhos, nariz, boca ou a máscara sem higienizar as mãos antes; compartilhar objetos de uso pessoal.",
						"title":"Como se prevenir?",
						"image":"images/games/informs/prevencao/1.png",
					},
					{
						"text":"Fique atento aos termos! ISOLAMENTO é o afastamento de indivíduos contaminados, que deve ser do primeiro dia da contaminação, (dia 1º) até 14º.",
						"title":"Como se prevenir?",
						"image":"images/games/informs/prevencao/1.png",
					},
					{
						"text":"QUARENTENA é o afastamento de indivíduos que podem ter tido contato com o vírus. Considerar do primeiro dia do contato (1º) até 14º.",
						"title":"Como se prevenir?",
						"image":"images/games/informs/prevencao/1.png",
					},
					{
						"text":"DISTANCIAMENTO FÍSICO é ficar fisicamente longe de outras pessoas (mínimo de 1,5 metros).",
						"title":"Como se prevenir?",
						"image":"images/games/informs/prevencao/1.png",
					},
					{
						"text":"Até o momento, não foram encontrados medicamentos capazes de curar a doença. Embora alguns médicos receitam remédios, estes servem apenas para aliviar sintomas.",
						"title":"Como se prevenir?",
						"image":"images/games/informs/prevencao/1.png",
					}
					
				],
				"pathImageGame":"midias/images/games/puzzles/prevencao/1.png"
			}
		]
	};
}

export {prevencao};
